import React, { useState } from 'react';
import ColumnChart from '../../../components/ColumnChart/ColumnChart';
import Toggler from '../../../components/Toggler/Toggler';
import { ChartStorageLevel } from '../../../core/models/gas';

import './SiteStorageToggler.scss';

interface ISiteStorageToggler {
  percent: ChartStorageLevel[];
  mcm: ChartStorageLevel[];
}

const togglerState = {
  percent: '%',
  mcm: 'mcm',
};

const yAxisTitles = {
  percent: '% Full',
  mcm: 'mcm',
};

export default function SiteStorageToggler({ percent, mcm }: ISiteStorageToggler): JSX.Element {
  const [chartData, setChartData] = useState<ChartStorageLevel[]>([...percent]);
  const [yAxisTitle, setYAxisTitle] = useState<string>(yAxisTitles.percent);

  const handleGasType = (output: string) => {
    if (output === togglerState.percent) {
      setChartData([...percent]);
      setYAxisTitle(yAxisTitles.percent);
    } else {
      setChartData([...mcm]);
      setYAxisTitle(yAxisTitles.mcm);
    }
  };

  return (
    <div className="SiteStorageToggler">
      <h3>UK Individual Site Storage Levels</h3>
      <div className="fcc">
        <div className="SiteStorageToggler__toggler">
          <Toggler
            leftText={togglerState.percent}
            rightText={togglerState.mcm}
            handler={handleGasType}
          />
        </div>
      </div>
      <div className="mb-3">
        <ColumnChart title={undefined} yAxisTitle={yAxisTitle} data={chartData} />
      </div>

      <div className="legend">
        <div className="legend-item red">LNG</div>
        <div className="legend-item blue">Gas</div>
      </div>
    </div>
  );
}
